export const image = {
    methods: {
        getAssetURL(imgPath) {
            const base = import.meta.env.VITE_CDN_ASSETS_PATH;
            let projectName = 'common';
            let pathWithoutProject = imgPath;
            if (imgPath.includes('/')){
                projectName = imgPath.split('/', 1)[0];
                pathWithoutProject = imgPath.replace(projectName + '/', '');
            }

            if (base){
                return new URL(base + '/' + imgPath).href;
            }
            if (projectName === 'common') return new URL('./../../../src/common/assets/' + pathWithoutProject, import.meta.url).href;

            return new URL('./../../../src/projects/' + projectName + '/assets/' + pathWithoutProject, import.meta.url).href;
        }
    }
};
